import {useCallback} from 'react'
import {useGameStore} from '../GameStoreContext'

export const useShareGameResults = () => {
    const shareGameResults = useGameStore((state) => state.gameEnd.endControls?.onClickShareGameResults)

    return useCallback(() => {
        if(shareGameResults) shareGameResults()
    }, [shareGameResults])
}
